import { Component, Inject, OnInit, Optional, Input, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DialogData } from '../../model/data.model';

@Component({
  selector: 'app-contact-number',
  templateUrl: './contact-number.component.html',
  styleUrls: ['./contact-number.component.css']
})
export class ContactNumberComponent implements OnInit {

  rmTollFreeNumber: boolean;
  b2cMessage: boolean;
  constructor(
    private dialogRef: MatDialogRef<ContactNumberComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { 

    if(data['editQuoteInfo']['source'] === 1) {

      this.rmTollFreeNumber = false;
      this.b2cMessage = true;
    } else {

      this.rmTollFreeNumber = true;
      this.b2cMessage = false;
    }
  }

  ngOnInit() {
  }

}
